import { useEffect } from 'react';

interface UseDocumentTitleProps {
  title: string;
}

export const useDocumentTitle = ({ title }: UseDocumentTitleProps) => {
  useEffect(() => {
    const previousTitle = document.title;
    const formattedTitle = title.includes(' - Legal Ops') 
      ? title 
      : `${title} - Legal Ops`;
    
    document.title = formattedTitle;
    
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};
